import { useCallback, useMemo, type ReactNode } from 'react';
import { MANDATE_BASE, productPath } from '../lib/productSurfacePaths';
import { ProductSurfaceContext } from './productSurfaceContextValue';

export function ProductSurfaceProvider({
  basePath,
  children,
}: {
  basePath: string;
  children: ReactNode;
}) {
  const to = useCallback((segment: string) => productPath(basePath, segment), [basePath]);
  const value = useMemo(
    () => ({
      basePath,
      isMandate: basePath === MANDATE_BASE,
      to,
    }),
    [basePath, to]
  );
  return (
    <ProductSurfaceContext.Provider value={value}>{children}</ProductSurfaceContext.Provider>
  );
}
